import { SpinResponse } from '@cgs/data-access';
import { Container, IntervalAction } from '@cgs/wge';
import { RespinAction } from '../../reels_engine/actions/respin_action';
import { SpinAction } from '../../reels_engine/actions/spin_action';
import {
  GAME_STATE_MACHINE_PROVIDER_TOKEN,
  IGameStateMachineProvider,
} from '../../reels_engine/game_components_providers/i_game_state_machine_provider';
import { IReelsEngineProvider } from '../../reels_engine/game_components_providers/i_reels_engine_provider';
import { AbstractGameConfig } from '../../reels_engine/game_config/abstract_game_config';
import { ReelsEngine } from '../../reels_engine/reels_engine';
import { RegularSpinsSoundModel } from '../../reels_engine/reels_sound_model';
import { GameStateMachine } from '../../reels_engine/state_machine/game-state-machine';
import {
  T_IGameConfigProvider,
  T_ISlotGameEngineProvider,
  T_RegularSpinsSoundModelComponent,
} from '../../type_definitions';
import { IStartSlotActionProvider, SpinMode } from './i_start_slot_action_provider';
import { IGameConfigProvider } from './interfaces/i_game_config_provider';
import { RegularSpinsSoundModelComponent } from './regular_spins_sound_model_component';

export class SpinActionComponent implements IStartSlotActionProvider {
  private readonly _container: Container;
  private readonly _gameStateMachine: GameStateMachine<SpinResponse>;
  private readonly _reelsEngine: ReelsEngine;
  private readonly _gameConfig: AbstractGameConfig;
  private readonly _regularSpinSoundModel: RegularSpinsSoundModel;
  private readonly _useSounds: boolean;

  constructor(container: Container, useSounds: boolean = true) {
    this._container = container;
    this._reelsEngine =
      this._container.resolve<IReelsEngineProvider>(T_ISlotGameEngineProvider).reelsEngine;
    this._gameStateMachine = this._container.resolve<IGameStateMachineProvider>(
      GAME_STATE_MACHINE_PROVIDER_TOKEN
    ).gameStateMachine;
    this._gameConfig =
      this._container.resolve<IGameConfigProvider>(T_IGameConfigProvider).gameConfig;
    this._regularSpinSoundModel = this._container.resolve<RegularSpinsSoundModelComponent>(
      T_RegularSpinsSoundModelComponent
    ).regularSpinSoundModel;
    this._useSounds = useSounds;
  }

  protected get container(): Container {
    return this._container;
  }

  protected get gameStateMachine(): GameStateMachine<SpinResponse> {
    return this._gameStateMachine;
  }

  protected get reelsEngine(): ReelsEngine {
    return this._reelsEngine;
  }

  protected get gameConfig(): AbstractGameConfig {
    return this._gameConfig;
  }

  protected get regularSpinSoundModel(): RegularSpinsSoundModel {
    return this._regularSpinSoundModel;
  }

  protected get useSounds(): boolean {
    return this._useSounds;
  }

  getStartSlotAction(spinMode: SpinMode): IntervalAction {
    switch (spinMode) {
      case SpinMode.ReSpin:
        return new RespinAction(
          this._container,
          this._reelsEngine,
          this._gameStateMachine,
          this._gameConfig.regularSpinConfig,
          this._gameConfig.freeSpinConfig,
          this._regularSpinSoundModel,
          this._useSounds
        );
      default:
        return new SpinAction(
          this._reelsEngine,
          this._gameStateMachine,
          this._gameConfig.regularSpinConfig,
          this._gameConfig.freeSpinConfig,
          this._regularSpinSoundModel,
          this._useSounds
        );
    }
  }
}
